import Axios from 'axios';
import { axiosTemplate } from '../../axiosTemplate';
// https://hxt3v2r6si.execute-api.us-east-1.amazonaws.com/test/v0/rest/dashboard
export const platformsDashboard = {
    endpoints: {
        test: `https://hxt3v2r6si.execute-api.us-east-1.amazonaws.com/test/v0/rest`,
        acceptance: `https://e67njegotl.execute-api.us-east-1.amazonaws.com/acceptance/v0/rest`,
        prod: `https://2wh024j21f.execute-api.us-east-1.amazonaws.com/prod/v0/rest`,
    },
    http: {
        create: ({ dashboard, stage, token, cancelToken, headers }) => {
            return axiosTemplate(token, cancelToken, headers).post(`${platformsDashboard.endpoints[stage]}/dashboard`, dashboard);
        },
        list: ({ stage, token, cancelToken, headers }) => {
            return axiosTemplate(token, cancelToken, headers).get(`${platformsDashboard.endpoints[stage]}/dashboard`);
        },
        update: ({ dashboard, id, stage, token, cancelToken, headers }) => {
            return axiosTemplate(token, cancelToken, headers).put(`${platformsDashboard.endpoints[stage]}/dashboard/${id}`, dashboard);
        },
        remove: ({ id, stage, token, cancelToken, headers }) => {
            return axiosTemplate(token, cancelToken, headers).delete(`${platformsDashboard.endpoints[stage]}/dashboard/${id}`);
        },
        get: ({ id, stage }) => {
            return Axios.get(`${platformsDashboard.endpoints[stage]}/dashboard/${id}`);
        },
        getData: ({ id, stage }) => {
            return Axios.get(`${platformsDashboard.endpoints[stage]}/dashboard/${id}/data`);
        },
    },
};
